import { Component } from 'react'
import { IS_LOGIN } from '../constants'

export default class AuthComponent extends Component {

    componentDidMount() {
        console.log("AuthComponent componentDidMount");
        if (localStorage.getItem(IS_LOGIN) === 'false') {
            console.log("AuthComponent componentWillMount go to /login page");
            window.location.href = "/login";
        }
    }

}


